import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {AdministratorGroupsActions} from '../store';
import {AdministratorGroupsSelectors} from '../store/selectors';

@Injectable()
export class AdministratorGroupsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadAdministratorGroupDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadAdministratorGroupDone() {

    return this.store.pipe(
      select(AdministratorGroupsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(AdministratorGroupsActions.LoadAdministratorGroups());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
